import { github } from 'react-code-blocks';
import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import { Select } from '@style/global-style.app';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const customStyleCodeBlock = {
  maxHeight: '420px',
  overflowY: 'auto',
  overflowX: 'auto',
  borderRadius: '5px',
  fontSize: '0.75rem',
  padding: '8px 0',
  marginLeft: '-16px',
};

export const themeCodeBlock = {
  theme: { ...github, backgroundColor: 'transparent' } as unknown as DefaultTheme,
  showLineNumbers: true,
  wrapLines: true,
  codeBlock: true,
  customStyle: customStyleCodeBlock,
};

export const WrapperLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const MainLink = styled(Text).attrs({
  color: ColorEnum.Black100,
  level: 'xxl',
})`
  position: relative;
`;

export const FullLink = styled(Text).attrs({
  paragraph: true,
  color: ColorEnum.Black70,
  level: 'xs',
  mb: 0,
})`
  width: 100%;
`;

export const RunButton = styled(Button).attrs({
  ghost: true,
  type: ButtonTypeEnum.Primary,
  size: 'small',
})`
  width: 120px;
  margin-left: auto;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CodeSelect = styled(Select)`
  &.ant-select {
    width: 150px;
  }

  &.ant-select-open .ant-select-selection-item,
  & .ant-select-selection-item {
    font-size: 12px;
  }
`;
